<template>
  <el-scrollbar style="width: 100%;height: 100%;overflow: auto" always>
    <el-form style="margin-top: 10px;">
      <el-form-item label="公司：" label-position="right" label-width="150px" required>
        <el-select style="width:80%" v-model="company_id" placeholder="企业名称/关键词/编号" clearable :disabled="isDisable"
                   filterable remote :remote-method="getCompanyByRemote" >
          <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="操作：" label-position="right" label-width="150px" required>
        <el-select style="width:50%" v-model="operation" placeholder="选择操作" :disabled="isDisable">
          <el-option v-for="item in operateList" :key="item.value" :label="item.name" :value="item.value" ></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <!-----------------------新增序列号----------------->
    <AddSnOperate v-if="operation === 'add'" :parent-data="parentData"
                  :is-disable="isDisable" :company-id="company_id"></AddSnOperate>

    <!-----------------------合并序列号----------------->
    <MergeSnOperate v-if="operation === 'merge'" :parent-data="parentData"
                    :is-disable="isDisable" :company-id="company_id"></MergeSnOperate>

    <!-----------------------停用序列号----------------->
    <StopUsingSnOperate v-if="operation === 'stop_using'" :parent-data="parentData"
                        :is-disable="isDisable" :company-id="company_id"></StopUsingSnOperate>

    <!-----------------------拆分序列号----------------->
    <SplitSnOperate v-if="operation === 'split'" :parent-data="parentData"
                    :is-disable="isDisable" :company-id="company_id"></SplitSnOperate>

    <!-----------------------变更产品明细----------------->
    <ChangeProductOperate v-if="operation === 'change_product'" :parent-data="parentData"
                          :is-disable="isDisable" :company-id="company_id"></ChangeProductOperate>

    <!-----------------------更新维护期----------------->
    <UpdateMaintenanceOperate v-if="operation === 'update_maintenance'" :parent-data="parentData"
                              :is-disable="isDisable" :company-id="company_id"></UpdateMaintenanceOperate>

  </el-scrollbar>
</template>

<script>
import AddSnOperate from "./AddSnOperate.vue";
import MergeSnOperate from "./MergeSnOperate.vue";
import StopUsingSnOperate from "./StopUsingSnOperate.vue";
import SplitSnOperate from "./SplitSnOperate.vue";
import ChangeProductOperate from "./ChangeProductOperate.vue";
import UpdateMaintenanceOperate from "./UpdateMaintenanceOperate.vue";

export default {
  name: "AfterSalesAssetOperate",
  components: {
    UpdateMaintenanceOperate,
    ChangeProductOperate, SplitSnOperate, StopUsingSnOperate, MergeSnOperate, AddSnOperate},

  data() {
    return {
      companyList:[],
      company_id:'',
      operation:'',
      isDisable:false
    }
  },
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },

  computed: {
    operateList(){
      return this.$store.getters['core/getDictList']('asset_operate');
    },
  },

  mounted() {
    this.isDisable = this.parentData.is_disable === 'true'
    if(this.isDisable){
      this.initData();
    }
  },

  methods: {
    async getCompanyByRemote(value) {
      this.companyList = await this.$http('companyService.getCompanyRemote', {value: value});
    },

    async initData(){
      let assetObj = await this.$http('assetService.getAssetInfoBySn',{serial_number: this.parentData.serial_number});
      await this.getCompanyByRemote(assetObj.company_id);
      this.company_id = assetObj.company_id;
      this.operation = this.parentData.operate;
    }
  }
}
</script>

<style scoped>

</style>